export default "__VITE_ASSET__DAiM1hPz__"